import React from "react";
import {
  Button,
  FormControl,
  InputLabel,
  Typography,
  withStyles,
} from "@material-ui/core";

const styles = () => ({
  displayForm: { display: "block", marginBottom: 25 },
  title: {
    fontSize: "14px!important",
  },
  label: {
    fontSize: "10px!important",
  },
  originValue: {
    paddingTop: "15px",
    fontFamily: "Roboto",
    fontSize: "13px",
    fontWeight: 400,
    color: "#e2e2e3",

    "& p": {
      fontFamily: "inherit",
      fontSize: "13px",
      color: "#e2e2e3",
    },
  },
  button: {
    fontSize: "0.625rem",
    fontWeight: 500,
    color: "#A8A8A8",
    padding: "0.37rem 0.5rem",
    letterSpacing: "1px",
    background: "#272727",
    border: "1px solid #1D1D1D",
    borderRadius: "4px",
    "&:hover": {
      background: "#353539",
    },
  },
  buttonIcon: {
    marginRight: "0.5rem",
    color: "#BDBDBD",
    width: "1rem",
    height: "1rem",
  },
});

/** Componente título da aba Propriedades do menu lateral direito. */
export const SectionTitle = withStyles(styles)(
  ({ classes, children }: { classes: any; children: any }) => {
    return (
      <FormControl className={classes.displayForm}>
        <InputLabel shrink={true} className={classes.title}>
          {children}
        </InputLabel>
      </FormControl>
    );
  }
);

/** Componente que exibe label e valor da aba Propriedades do menu lateral direito. */
export const DisplayValue = withStyles(styles)(
  ({
    classes,
    label,
    value,
  }: {
    classes: any;
    label: string;
    value: React.ReactElement | string;
  }) => {
    return (
      <FormControl className={classes.displayForm}>
        <InputLabel shrink={true} className={classes.label}>
          {label}
        </InputLabel>
        <Typography className={classes.originValue} component="div">
          {value}
        </Typography>
      </FormControl>
    );
  }
);

/** Componente que exibe label e botão de ação da aba Propriedades do menu lateral direito. */
export const DisplayButton = withStyles(styles)(
  ({
    classes,
    title,
    buttonTestId,
    buttonLabel,
    Icon,
    onClick,
  }: {
    classes: any;
    title: string;
    buttonTestId: string;
    buttonLabel: string;
    Icon: (props: any) => JSX.Element;
    onClick?: (ev: any) => void;
  }) => {
    return (
      <FormControl className={classes.displayForm}>
        <InputLabel shrink={true} style={{ width: "max-content" }}>
          {title}
        </InputLabel>
        <Typography
          className={classes.originValue}
          component="div"
        ></Typography>
        <Button
          data-testid={buttonTestId}
          variant="contained"
          className={classes.button}
          style={{
            color: "rgba(255, 255, 255, 0.6)",
            margin: "5px -2px",
          }}
          onClick={onClick}
        >
          <Icon className={classes.buttonIcon} />
          {buttonLabel}
        </Button>
      </FormControl>
    );
  }
);



// WEBPACK FOOTER //
// ./src/modules/projectRightMenu/components/layouts/RowProperties/Components.tsx